<template>
    <div id="verifyId" class="">

        <!-- <h4 class="mb-3">We Need To Verify Your Identity</h4> -->

        <!-- LOADING FORM SPINNER-->
        <vue-element-loading
            :active="loading"
            spinner="bar-fade-scale"
            color="#FF6700"
            text="Please stand by..."/>
        <!-- LOADING FORM SPINNER END-->

        <div v-cloak v-if="type == 'kba'">
            <kba-section
                @loading="setLoading"
                :questions="questions"
                :trackkey="trackingKey">
            </kba-section>
        </div>

        <div v-cloak v-if="type == 'otp'">
            <otp-section
                @loading="setLoading"
                :phone="phone"
                :trackkey="trackingKey">
            </otp-section>
        </div>

    </div>
</template>

<script>

import VueElementLoading from "vue-element-loading";
import Kba from '.././verify/Kba';
import Otp from '.././verify/Otp';

export default {
    props: ['type', 'phone', 'tudata', 'trackkey', 'host'],
    components: {
        'vue-element-loading' : VueElementLoading,
        'kba-section' : Kba,
        'otp-section' : Otp,
    },
    data() {
        return {
            verifyType : null,
            typeSelected : null,
            loadingAsyncRequest : false,
            baseUrl : this.host
        }
    },
    computed: {
        loading() {
            return this.loadingAsyncRequest;
        },
        isTypeSelected() {
            return false;
        },
        tuData() {
            return JSON.parse(this.tudata);
        },
        questions() {
            return this.tuData.questions;
        },
        trackingKey() {
            return this.trackkey;
        },
        baseUrl() {
            return this.$parent.baseUrl;
        }
    },
    watch: {

    },
    methods: {
        setLoading(data) {
            this.loadingAsyncRequest = data.loading;
        }
    },
    mounted() {
        console.log(this.tudata)
    }
}
</script>


<style lang="scss">
// @import './../../sass/partials/form.scss';
.step-leave-active,
.step-enter-active {
  transition: 300ms;
}
.step-enter {
  transform: translate(100%, 0);
}
.step-leave-to {
  transform: translate(-100%, 0);
}
</style>
